import { createContext } from 'react';

export const DoubleViewContext = createContext<DoubleViewContext>({
	index: 0,
	pages: [],
	setSwiper: () => {},
	setIndex: () => {},
	onNextArticleClick: () => {},
	onPrevArticleClick: () => {},
	toggleMenu: () => {},
	isProfileMenuOpen: false,
	setIsProfileMenuOpen: () => {},
});

interface DoubleViewContext {
	swiper?: any;
	setSwiper: Function;
	index: number;
	setIndex: Function;
	pages: Array<any>;
	onNextArticleClick: Function;
	onPrevArticleClick: Function;
	toggleMenu: () => void;
	isProfileMenuOpen: boolean;
	setIsProfileMenuOpen: (v: boolean) => void;
}
